import React, { useState } from 'react';
import { connect } from 'react-redux';
import LocalizedMessage from 'react-l10n';
import moment from 'moment';
import Reports from '../components/Reports';
import { axiosRequestReportRead } from '../../main/actions/reportActions';
import { handleAxiosErrors } from '../_utils';

const ReportsContainer = (props) => {
    const { reportTypeList } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [reportType, setReportType] = useState('');
    const [displayReportHeader, setDisplayReportHeader] = useState('');
    const [startDate, setStartDate] = useState(
        moment()
            .subtract(1, 'months')
            .format('DD/MM/YYYY')
    );
    const [endDate, setEndDate] = useState(moment().format('DD/MM/YYYY'));

    const [columns, setColumns] = useState([]);
    const [products, setProducts] = useState([]);

    const momentStartDate = startDate ? moment(startDate, 'DD/MM/YYYY') : null;
    const momentEndDate = endDate ? moment(endDate, 'DD/MM/YYYY') : null;

    const request = () => {
        setIsLoading(true);

        setColumns([]);
        setProducts([]);

        return axiosRequestReportRead({
            reportType,
            startDate: momentStartDate.format('YYYY-MM-DD'),
            endDate: momentEndDate.format('YYYY-MM-DD'),
        })
            .then((response) => {
                const columns = response['data']['headers'].map((x) => {
                    return {
                        dataField: x.Title,
                        text: x.Title,
                        sort: x.Sortable,
                        formatter: (cell, row) => {
                            if (x.Round) {
                                return parseFloat(cell).toFixed(x.Round);
                            }

                            return cell;
                        },
                        headerStyle: (colum, colIndex) => {
                            return {
                                width: '100px',
                                fontSize: '0.75em',
                                fontWeight: '400',
                                fontFamily: 'Helvetica Neue LT W05_65 Medium',
                                textTransform: 'uppercase',
                                color: '#000',
                                letterSpacing: '0.05em',
                                whiteSpace: 'nowrap',
                            };
                        },
                        style: () => {
                            return {
                                fontSize: '0.875em',
                                fontWeight: 400,
                                fontFamily: "Helvetica Neue LT W05_55 Roman",
                                verticalAlign: 'middle',
                                lineHeight: '120%',
                            }
                        }
                    };
                });
                const products = response['data']['rows'];
                setColumns(columns);
                setProducts(products);
                const reportTypeLabel = reportTypeList.find(x => x.value === reportType).label;
                setDisplayReportHeader(
                    `${reportTypeLabel} - ${startDate} to ${endDate}`
                );
                setIsLoading(false);
            })
            .catch((error) => {
                handleAxiosErrors(error);
                setIsLoading(false);
            });
    };

    return (
        <Reports
            {...props}
            isLoading={isLoading}
            columns={columns}
            products={products}
            reportTypeList={reportTypeList}
            reportType={reportType}
            setReportType={setReportType}
            startDate={startDate}
            momentStartDate={momentStartDate}
            setStartDate={setStartDate}
            endDate={endDate}
            momentEndDate={momentEndDate}
            setEndDate={setEndDate}
            generateReport={request}
            displayReportHeader={displayReportHeader}
            setDisplayReportHeader={setDisplayReportHeader}
        />
    );
};

const mapStateToProps = function(store) {
    let reportTypeList = typeof window.reports != 'undefined'
    ? JSON.parse(window.reports)
    : [];

    reportTypeList = [
        {
            label: '-',
            value: '',
        },
        ...reportTypeList
    ];

    return {
        reportTypeList,
    };
};

const mapDispatchToProps = function(dispatch, ownProps) {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportsContainer);
